if (!customElements.get('right-drawer')) {
    class RightDrawer extends HTMLElement {
        constructor() {
            super();
            this.id = this.dataset.drawerId;
            this.isOpen = false;
            this.classList.remove('fixed');
            this.classList.add('hidden');
        }

        connectedCallback() {
            if (this.closest('main')) document.body.insertBefore(this, document.body.firstChild);

            window.addEventListener('click', e => {
                const clickedElement = e.target.closest('[data-right-drawer-action]');
                if (!clickedElement) {
                    if (this.isOpen && !this.contains(e.target) && !e.target.closest('input')) this.close();
                    return;
                }

                const {
                    rightDrawerAction: action,
                    drawerId
                } = clickedElement.dataset;

                switch (action) {
                    case 'open':
                        if (drawerId === this.id) this.open();
                    break;
                    case 'close':
                        if (drawerId === this.id) this.close();
                    break;
                    default: break;
                }
            })
        }

        open() {
            this.isOpen = true;
            this.classList.replace('hidden', 'fixed');
            setTimeout(() => {
                this.classList.remove('translate-x-full');
                this.querySelector('[data-right-drawer-action="close"]')?.focus();
            }, 10);
            document.body.classList.add('overlay');
        }

        close() {
            this.isOpen = false;
            this.classList.add('translate-x-full');
            document.querySelector(`[data-right-drawer-action="open"][data-drawer-id="${this.id}"`)?.focus();
            document.body.classList.remove('overlay');
            setTimeout(() => {
                this.classList.replace('fixed', 'hidden');
            }, 500);
        }
    }

    customElements.define('right-drawer', RightDrawer);
}